<!-- CheckupRiskGraphic.vue -->
<template>
  <div :class="invisible ? 'tw-h-0 tw-overflow-hidden' : ''">
    <div
      ref="content"
      class="tw-pt-24"
      style="border: 1px solid transparent;"
    >
      <div class="tw-my-20 tw-mx-10 tw-px-10">
        <NumberLine
          :min="0"
          :max="100"
          :sections="sections"
          :markers="markers"
          gradient="#2978ba,#759887,#f1cd33,#e28b3f,#d24c48"
          class="tw-text-slate-800 tw-text-sm tw-border-slate-400"
          @markerClick="handleMarkerClick"
        />
      </div>
    </div>
  </div>
</template>


<script>
import html2canvas from 'html2canvas';
import NumberLine from '@frontend/ui/components/utils/numberline/NumberLine.vue';

import { mapStores } from 'pinia';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';

export default {
  name: 'CheckupRiskGraphic',
  components: { NumberLine },
  props: {
    name: {
      type: String,
    },
    chartConfig: {
      type: Object,
      required: true,
    },
    exportImage: {
      type: Boolean,
      default: false,
    },
    invisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id: null,
      sections: [
        { label: 'Conservative' },
        { label: 'Moderately Conservative' },
        { label: 'Moderate' },
        { label: 'Moderately Aggressive' },
        { label: 'Aggressive' },
      ],
    };
  },
  computed: {
    ...mapStores(useCheckupStore),

    markers() {
      if (!this.chartConfig?.datasets) return [];
      const riskMarkers = this.chartConfig.datasets
        .map(dataset => ({
          label: dataset.label,
          value: dataset.data[0], // Risk score
          color: dataset.backgroundColor,
          showValue: true,
        }))
        .filter(marker => marker.value !== null && marker.value !== undefined); // Remove invalid markers

      if (this.checkupStore.showClientRiskScore && this.checkupStore.clientRisk && this.checkupStore.clientRisk.value !== undefined) {
        riskMarkers.push({
          value: this.checkupStore.clientRisk.value,
          label: 'Client Risk Score',
          color: '#999999',
          showValue: false,
        });
      }

      return riskMarkers.filter(marker => marker.value !== null && marker.value !== undefined); // Final cleanup
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
    'checkupStore.chartImageUpdateRequested'() {
      this.toImage();
    },
  },
  created() {
    this.id = 'image-' + this.createID();
  },
  mounted() {
    // this.toImage();
  },
  destroyed() {
    this.$emit('image-removed', { id: this.id, name: this.name });
  },
  updated() {
    // window.setTimeout(() => this.toImage(), 200);
  },
  methods: {
    createID() {
      return Math.random().toString(36).substring(2, 9);
    },
    async getImageMetadata(src) {
      const img = new Image();
      img.src = src;
      await img.decode();
      return img;
    },
    async toImage() {
      if (!this.exportImage) return;
      console.log('Updating risk graphic image');
      const canvas = await html2canvas(this.$refs.content);
      const base64String = canvas.toDataURL('image/png');

      const { naturalWidth, naturalHeight } = await this.getImageMetadata(base64String);
      const aspectRatio = naturalWidth / naturalHeight;

      this.$emit('image-changed', { id: this.id, image: { base64String, aspectRatio } });
    },
    handleMarkerClick(marker) {
      this.$emit('chartClick', marker);
    },
  },
};
</script>


<style scoped>
table {
  border-collapse: collapse;
  background-color: #f9f9f9; /* Light gray background for better contrast */
}

th, td {
  padding: 6px 9px; /* Padding for cell content */
  border: 1px solid #e0e0e0; /* Light gray border */
  text-align: left;
}

th:first-child, td:first-child {
    text-align: right;  /* This right-aligns the first column */
}

thead {
  background-color: #e0e0e0; /* Slightly darker header for distinction */
}

tbody tr:hover {
  background-color: #f1f1f1; /* Subtle hover effect */
}
</style>
